"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campodenno": {
    "3134f82d": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "skipSearch": false
    }],
    "ischia": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ab672d8": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "skipSearch": false
    }],
    "maso-bolner": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e2eccab": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "skipSearch": false
    }],
    "maso-sant-angelo": [{
      "hkey": "0dc1760a",
      "slug": "campodenno",
      "name": "Campodenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;